/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';

export default class TopMenu {
    constructor(el) {
        this.el = el;
    }
    init() {
    let self = this;
      self.el.hoverIntent({
          over: self.toggleClassSubMenu,
          out: self.toggleClassSubMenu,
          selector: ' > li',
          timeout:100
      });
    }

    toggleClassSubMenu(){
        let _item = $(this);
        let expanded = _item.attr('aria-expanded');
        if(typeof expanded !=="undefined"){
         expanded = (expanded.toLowerCase() === 'true');
        _item.toggleClass('menu__item--active').attr('aria-expanded',!expanded);
        $('.menu-sub',_item).attr('aria-expanded',!expanded).attr('aria-hidden',expanded);
        }

    }
}



// WEBPACK FOOTER //
// ./js/components/top-menu.js